module.exports = {
  API_URL: 'https://api.katario.com',
  WEBSITE_URL: 'https://katario.com',
  STRIPE_PKEY: 'pk_live_51JKj3cFTBB1tFXYjcIOp91LZ9GcvXpOpmj0jkApDnHezyWBUHlScV9ZP0xb29u15SB4RTbMlZzaBAdCNKYqhXJLP00BwziEzIl',
  LOGIN_PAGE_URL: 'https://katario.com/account/login',
  WEBAPP_URL: 'https://app.katario.com',
  NOTIFICATION_URL: 'https://webhook.katario.com',
};